import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
//import PropTypes from "prop-types";
import { Container, Row, Col } from "shards-react";

import MainNavbar from "../components/layout/MainNavbar/MainNavbar";
import MainSidebar from "../components/layout/MainSidebar/MainSidebar";

import routes from "./../routes";

const SUB_DOMAIN = process.env.REACT_APP_SUB_DOMAIN;

const CommonpageLayout = ({ noNavbar }) => (

  <Router basename={SUB_DOMAIN}>
    <Container fluid>
      <Row>
      {!noNavbar && <MainSidebar />}
        <Col
          className="main-content p-0"
          lg={{ size: 10, offset: 2 }}
          md={{ size: 9, offset: 3 }}
          sm="12"
          tag="main"
        >
         {!noNavbar && <MainNavbar />}
        {/* {!noFooter && <MainFooter />} */}
        
          <Switch>
            {routes.map((route, index) => {
              return (
                <Route
                  key={"route-" + index}
                  path={route.path}
                  exact={route.exact || true}
                  component= {route.component}
                />
              );
            })}
          </Switch>
        </Col>
      </Row>
    </Container>
  </Router>

);

// DefaultLayout.propTypes = {
//   /**
//    * Whether to display the navbar, or not.
//    */
//   noNavbar: PropTypes.bool,
//   /**
//    * Whether to display the footer, or not.
//    */
//   noFooter: PropTypes.bool
// };

// DefaultLayout.defaultProps = {
//   noNavbar: false,
//   noFooter: false
// };

export default CommonpageLayout;
